export default __webpack_public_path__ + "static/jardin1-d62c52e2b97118d0eef1b530ee577e1a.png";